import type { AddWipRecordFromScheduleRequestBodyDTO } from 'declarations/dto/wip';

import { post } from './api';

export const addWipRecordFromScheduleApi = async (
  body: AddWipRecordFromScheduleRequestBodyDTO
): Promise<void> => {
  await post<void>('/wip/records/from-schedule', body);
};
